export default __webpack_public_path__ + "images/disc9d3394.png";